/**
 * @file TransferSourceCell.tsx
 * @description Ячейка «Основание» реестра перемещений (phase19.31, зона
 * «Склад»): вид документа («Лист размещения», «Быстрое действие») и номер
 * приёмки-основания ссылкой. Колонка не первая — строка-ссылка таблицы
 * нажатие по ней не перехватывает.
 */

import { Link } from "react-router";

import { TwoLineCell } from "../../ui/TwoLineCell";
import { TRANSFER_SOURCE_LABEL, type TransferListItemDto } from "../../../lib/api-transfers";

interface Props {
  transfer: TransferListItemDto;
  /** База адреса приёмок: `/shop/:slug/wms/receipts`. */
  receiptsPath: string;
}

export function TransferSourceCell({ transfer, receiptsPath }: Props) {
  if (transfer.source === "MANUAL") return <span className="text-on-surface-variant">—</span>;
  const label = TRANSFER_SOURCE_LABEL[transfer.source];
  if (!transfer.receipt) return <TwoLineCell primary={label} />;
  return (
    <TwoLineCell
      primary={label}
      secondary={
        <Link to={`${receiptsPath}/${transfer.receipt.id}`} className="font-mono text-primary hover:underline">
          {transfer.receipt.receiptNumber}
        </Link>
      }
    />
  );
}
